"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FillInTheBlankCell = void 0;
const material_1 = require("@mui/material");
const types_1 = require("../../gameplay/types");
const react_1 = __importDefault(require("react"));
const utils_1 = require("../../utils");
function FillInTheBlankCell(props) {
    switch (props.displayMode) {
        case 'UNDERLINE': {
            return (react_1.default.createElement(material_1.ThemeProvider, { theme: (0, utils_1.getTheme)(props.gameplayStyle) },
                react_1.default.createElement("div", { onClick: () => {
                        if (props.onInteract) {
                            props.onInteract(props.blankIndex);
                        }
                    } },
                    react_1.default.createElement(material_1.Typography, { variant: "h5", sx: {
                            width: props.inputMode === 'SPELLING'
                                ? `${getBlankWidth(props.gameplayControl, props.input, props.expectedInput)}ch`
                                : 'fit-content',
                            color: getTypographyColor(props.gameplayControl, props.input, props.expectedInput, props.gameplayStyle),
                            borderBottom: `5px dotted ${getBorderBottomColor(props.displayMode, props.active, props.gameplayStyle, props.gameplayControl, props.input, props.expectedInput)}`,
                            textAlign: `${[types_1.GameplayControl.PresentAnswerWithCorrectResponse, types_1.GameplayControl.PresentAnswerWithIncorrectResponse].includes(props.gameplayControl) ? 'center' : 'center'}`,
                            // fontSize: `${getFontSize(props.size)}px`,
                            fontFamily: 'Bryant',
                            fontWeight: 700,
                            lineHeight: '28px',
                            fontStyle: 'normal',
                        } }, getText(props.gameplayControl, props.input, props.expectedInput, props.displayMode)))));
        }
        case 'SQUARE_NORMAL': {
            return (react_1.default.createElement("div", { onClick: () => {
                    if (props.onInteract) {
                        props.onInteract(props.blankIndex);
                    }
                }, style: {
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: `${getSquareWidth(props.size)}px`,
                    height: `${getSquareWidth(props.size)}px`,
                    aspectRatio: 1,
                    border: `1px solid ${getBorderBottomColor(props.displayMode, props.active, props.gameplayStyle, props.gameplayControl, props.input, props.expectedInput)}`,
                } },
                react_1.default.createElement(material_1.Typography, { sx: {
                        color: getTypographyColor(props.gameplayControl, props.input, props.expectedInput, props.gameplayStyle),
                        textAlign: 'center',
                        fontSize: `${getFontSize(props.size)}px`,
                    } }, getText(props.gameplayControl, props.input, props.expectedInput, props.displayMode))));
        }
        case 'SQUARE_SUPERSCRIPT': {
            return (react_1.default.createElement("div", { onClick: () => {
                    if (props.onInteract) {
                        props.onInteract(props.blankIndex);
                    }
                }, style: {
                    width: `${getSquareWidth(props.size)}px`,
                    height: `${getScriptHeight(props.size)}px`,
                    display: 'flex',
                    flexDirection: 'column',
                } },
                react_1.default.createElement("div", { style: {
                        flex: 'none',
                        aspectRatio: 1,
                        border: `1px solid ${getBorderBottomColor(props.displayMode, props.active, props.gameplayStyle, props.gameplayControl, props.input, props.expectedInput)}`,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                    } },
                    react_1.default.createElement(material_1.Typography, { sx: {
                            color: getTypographyColor(props.gameplayControl, props.input, props.expectedInput, props.gameplayStyle),
                            textAlign: 'center',
                            fontSize: `${getFontSize(props.size)}px`,
                        } }, getText(props.gameplayControl, props.input, props.expectedInput, props.displayMode))),
                react_1.default.createElement("div", { className: "flex-grow" })));
        }
        case 'SQUARE_SUBSCRIPT': {
            return (react_1.default.createElement("div", { onClick: () => {
                    if (props.onInteract) {
                        props.onInteract(props.blankIndex);
                    }
                }, style: {
                    width: `${getSquareWidth(props.size)}px`,
                    height: `${getScriptHeight(props.size)}px`,
                    display: 'flex',
                    flexDirection: 'column',
                } },
                react_1.default.createElement("div", { className: "flex-grow" }),
                react_1.default.createElement("div", { style: {
                        flex: 'none',
                        aspectRatio: 1,
                        border: `1px solid ${getBorderBottomColor(props.displayMode, props.active, props.gameplayStyle, props.gameplayControl, props.input, props.expectedInput)}`,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                    } },
                    react_1.default.createElement(material_1.Typography, { sx: {
                            color: getTypographyColor(props.gameplayControl, props.input, props.expectedInput, props.gameplayStyle),
                            textAlign: 'center',
                            fontSize: `${getFontSize(props.size)}px`,
                        } }, getText(props.gameplayControl, props.input, props.expectedInput, props.displayMode)))));
        }
        default:
            return react_1.default.createElement("div", null);
    }
}
exports.FillInTheBlankCell = FillInTheBlankCell;
function getBorderBottomColor(displayMode, active, gameplayStyle, gameplayControl, input, expectedInput) {
    const nonQuestionControls = [
        types_1.GameplayControl.Pending,
        types_1.GameplayControl.PresentAnswerWithCorrectResponse,
        types_1.GameplayControl.PresentAnswerWithIncorrectResponse,
    ];
    switch (displayMode) {
        case 'UNDERLINE':
            if (nonQuestionControls.includes(gameplayControl)) {
                return '#00000000';
            }
            if (active) {
                return '#FFEC4F';
            }
            else {
                if (input.length === expectedInput.length) {
                    return '#00000000';
                }
                else {
                    switch (gameplayStyle) {
                        case types_1.GameplayStyle.PopStudy:
                            return 'black';
                        case types_1.GameplayStyle.PopQuiz:
                            return 'white';
                        case types_1.GameplayStyle.PopQuizHost:
                            return '#FFEC4F';
                        default:
                            return 'white';
                    }
                }
            }
        default:
            if (nonQuestionControls.includes(gameplayControl)) {
                return '#FFEC4F';
            }
            if (active) {
                return '#FFEC4F';
            }
            else {
                switch (gameplayStyle) {
                    case types_1.GameplayStyle.PopStudy:
                        return 'black';
                    case types_1.GameplayStyle.PopQuiz:
                        return 'white';
                    case types_1.GameplayStyle.PopQuizHost:
                        return '#FFEC4F';
                    default:
                        return 'white';
                }
            }
    }
}
function getBlankWidth(gameplayControl, input, expectedInput) {
    const answerControls = [
        types_1.GameplayControl.PresentAnswerWithCorrectResponse,
        types_1.GameplayControl.PresentAnswerWithIncorrectResponse,
    ];
    if (answerControls.includes(gameplayControl)) {
        return expectedInput.length;
    }
    return Math.max(input.length, expectedInput.length);
}
function getText(gameplayControl, input, expectedInput, displayMode) {
    switch (displayMode) {
        case 'UNDERLINE': {
            switch (gameplayControl) {
                case types_1.GameplayControl.PresentQuestion:
                case types_1.GameplayControl.Pending:
                    if (input.length === 0) {
                        return 'PH';
                    }
                    else {
                        return input;
                    }
                case types_1.GameplayControl.PresentAnswerWithCorrectResponse:
                    return expectedInput;
                case types_1.GameplayControl.PresentAnswerWithIncorrectResponse:
                    return input;
            }
        }
        // eslint-disable-next-line no-fallthrough
        default: {
            const answerControls = [
                types_1.GameplayControl.PresentAnswerWithCorrectResponse,
                types_1.GameplayControl.PresentAnswerWithIncorrectResponse,
            ];
            if (answerControls.includes(gameplayControl)) {
                return expectedInput;
            }
            return input;
        }
    }
}
function getFontSize(size) {
    switch (size) {
        case 'lg':
            return 48;
        case 'md':
            return 36;
        case 'sm':
            return 24;
        case 'xs':
            return 12;
    }
}
function getTypographyColor(gameplayControl, input, expectedInput, gameplayStyle) {
    switch (gameplayControl) {
        case types_1.GameplayControl.PresentQuestion:
        case types_1.GameplayControl.Pending:
            if (input.length === 0) {
                // transparent
                return '#00000000';
            }
            else if (input.length === expectedInput.length) {
                // has input
                switch (gameplayStyle) {
                    case types_1.GameplayStyle.PopStudy:
                        return '#456BF4';
                    default:
                        return '#BBDEFB';
                }
            }
            else {
                switch (gameplayStyle) {
                    case types_1.GameplayStyle.PopStudy:
                        return 'black';
                    default:
                        return 'white';
                }
            }
        case types_1.GameplayControl.PresentAnswerWithCorrectResponse:
            return '#4CAF50';
        case types_1.GameplayControl.PresentAnswerWithIncorrectResponse:
            if (input === expectedInput) {
                return '#4CAF50';
            }
            else {
                return '#EF5350';
            }
    }
}
function getSquareWidth(size) {
    switch (size) {
        case 'lg':
            return 64;
        case 'md':
            return 54;
        case 'sm':
            return 40;
        case 'xs':
            return 28;
    }
}
function getScriptHeight(size) {
    return getSquareWidth(size) * 2;
}
